import nextDynamic from 'next/dynamic';

const Content = nextDynamic(() => import('./collection-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
